
import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"

/* --- Types --- */

import { AuditTrailEntry } from "@/types/fieldReassignmentAudit"

/* --- Components --- */

import FieldReassignmentAuditTrailItem from "./FieldReassignmentAuditTrailItem.vue"

@Component({
	components: {
		"audit-trail-item": FieldReassignmentAuditTrailItem
	}
})
export default class FieldReassignmentAuditTrail extends Vue {
	@Prop({ type: Array, required: true }) private value!: AuditTrailEntry[]
	@Prop({ type: Number, default: 8 }) private displayLimit!: number

	/* --- Data --- */

	private showAllOverride = false

	/* --- Computed Properties --- */

	private get shouldShowAll (): boolean {
		return this.showAllOverride || this.value.length <= this.displayLimit
	}

	/**
	 * @summary Returns the earliest audit trail entries to display in truncated view.
	 */
	private get displayAuditsEarliest (): AuditTrailEntry[] {
		if (this.shouldShowAll) return []
		return this.value.slice(0, Math.floor(this.displayLimit / 2))
	}

	/**
	 * @summary Returns the latest audit trail entries to display in truncated view.
	 */
	private get displayAuditsLatest (): AuditTrailEntry[] {
		if (this.shouldShowAll) return []
		const recentLength = Math.ceil(this.displayLimit / 2)
		return this.value.slice(-recentLength)
	}
}
